import getRoleProperty from '../getRoleProperty';

class ContactRoleAdditionalInsuredCtrl {
    constructor() {
        this.$onInit = () => {
            const { fieldGetter } = getRoleProperty(this.roleType, this.roleModel, 'additionalInsured', 'policyAdditionalInsured');
            const types = fieldGetter(undefined, 'additionalInusredTypes.children') || [];
            this.additionalInsuredTypes = types.map(type => type.value.name);
        };
    }
}

export default ContactRoleAdditionalInsuredCtrl;
